// eslint-disable-next-line import/prefer-default-export
export const getRouteForProjectId = (id:string) => `/my-projects/offers/${id}`;
